/**
 * Enum for the dispatch status to ensure type safety.
 */
export enum DispatchStatus {
  PENDING = 'pending',
  SENT = 'sent',
  FAILED = 'failed',
}